// extracted by mini-css-extract-plugin
module.exports = {"root":"root-3BLXb","title":"title-1fOWT"};